import WebSocketContext from '../context/WebSocketContext';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { setIsFileProcessing } from '../store/slices/fileProcessingSlice';

const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  const dispatch = useDispatch();

  if (!context) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }

  const { 
    sendToWs, 
    sendBinaryToWs, 
    isConnected,
    initializeUser,
    switchToChat,
    waitForConnection
  } = context;

  const handleMessage = (event: MessageEvent) => {
    const data = JSON.parse(event.data as string);

    if (data.chunk && typeof data.chunk === 'string' && data.chunk.startsWith('^')) {
      dispatch(setIsFileProcessing(false));
      // ...existing code to handle the PDF file name...
    }

    // Handle other messages
    // ...existing code...
  };

  return {
    sendToWs,
    sendBinaryToWs,
    handleMessage,
    isConnected,
    initializeUser,
    switchToChat,
    waitForConnection
  };
};

export default useWebSocketContext;